import React from 'react'
import {observer} from 'mobx-react'
import SidebarSlide from './SidebarSlide'
import PropTypes from 'prop-types';
import './procedureSidebar.scss'
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {Button} from "@mui/material";
import {useStores} from "../../../Hooks";

const ProcedureSidebar = observer(props => {
    const {procedureStore, generalStore} = useStores();
    
    const {isPreview} = props;
    const {innerProcedureParentProcedureIds} = procedureStore;
    const innerProcedureParentProcedureId = innerProcedureParentProcedureIds[innerProcedureParentProcedureIds.length - 1];
    const parentProcedure = procedureStore.fetchedProceduresMap.get(innerProcedureParentProcedureId);
    const selectedNodes = isPreview
        ? procedureStore.sessionViewerOpen && !!procedureStore.currentPreviewedNode.selectedNodes
            ? procedureStore.currentPreviewedNode.selectedNodes.slice(1)
            : procedureStore.selectedPreviewedNodes.slice(1)
        : procedureStore.selectedNodes.slice(1);

    return (
        <React.Fragment>
            <div className="procedure-sidebar-background"/>
            <div className="procedure-sidebar">
                <ConditionalComponent if={!!procedureStore.innerProcedurePreviousStepsIds.length}>
                    <div className='sidebar-parent-procedure-nav'>
                        <Button onClick={() => procedureStore.goBackToParentProcedure(isPreview)}>
                            {generalStore.translate('goToPreviousStepSentence1_beforeName')}&nbsp;<b>{parentProcedure ? parentProcedure.ProcedureName : ''}</b>{generalStore.translate('goToPreviousStepSentence2_afterName')}
                        </Button>
                    </div>
                </ConditionalComponent>
                {selectedNodes.map((n, i) => (
                    <SidebarSlide
                        key={i}
                        index={i}
                        node={n}
                        isPreview={isPreview}
                    />
                ))}
                <ConditionalComponent if={!!procedureStore.innerProcedureNextStepIds.length}>
                    <div className='sidebar-parent-procedure-nav'>
                        <Button onClick={() => procedureStore.goNextToParentProcedure(isPreview)}>
                            {generalStore.translate('goToNextStepSentence1_beforeName')}&nbsp;<b>{parentProcedure ? parentProcedure.ProcedureName : ''}</b>{generalStore.translate('goToNextStepSentence2_afterName')}
                        </Button>
                    </div>
                </ConditionalComponent>
            </div>
        </React.Fragment>
    )
});

ProcedureSidebar.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default ProcedureSidebar
